import React, { useMemo } from 'react';
import ReactFlow, { Background, Controls } from 'reactflow';
import 'reactflow/dist/style.css';
import styled from 'styled-components/macro';
import { colourNeutral09 } from '../../../../styling/colours';
import { ManifoldFormModel } from '../manifolds/manifoldFormModel';
import { useTree } from './map-helpers/hooks/useTree';
import { generateMapFromTree } from './map-helpers/mapHelpers';
import { MapNodeType } from './mapNode';
import { MapStats } from './MapStats';
import { MapStatus } from './MapStatus';
import { HeatSource } from './node-types/HeatSource';
import { Manifold } from './node-types/Manifold';
import { Pipe } from './node-types/Pipe';
import { Pump } from './node-types/Pump';

type Props = {
  manifolds: Array<ManifoldFormModel>;
};

export const MapCanvas = ({ manifolds }: Props) => {
  const nodeTypes = useMemo(
    () => ({
      [MapNodeType.HeatSource]: HeatSource,
      [MapNodeType.Pipe]: Pipe,
      [MapNodeType.Pump]: Pump,
      [MapNodeType.Manifold]: Manifold,
    }),
    [],
  );
  const { tree, treeStatus } = useTree();
  const { map, edges } = generateMapFromTree(tree);

  return (
    <div>
      <MapStatus treeStatus={treeStatus} />
      <MapCanvasContainer>
        <MapStats map={map} manifolds={manifolds.filter(manifold => !manifold.isRadiator)} />
        <Map>
          <ReactFlow nodes={map} edges={edges} nodeTypes={nodeTypes} elementsSelectable={false}>
            <Background />
            <Controls position="top-right" />
          </ReactFlow>
        </Map>
      </MapCanvasContainer>
    </div>
  );
};

const MapCanvasContainer = styled.div`
  display: flex;
  width: 100%;
`;

const Map = styled.div`
  height: 1000px;
  width: 100%;
  border: 1px solid ${colourNeutral09};
`;
